import { Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  rating?: string;
};
const RatingCell = React.memo((row: KpiWorkunitGridData) => (
  <Typography variant="body2" noWrap>
    {row?.rating ?? '-'}
  </Typography>
));

export default RatingCell;
